import { IAuthInfoDTO, IEditPasswordRequestDTO, IAuthRequestDTO, ISSOAuthRequestDTO } from 'src/api/dtos';
import http from 'src/api/http';
import CommonRepository from 'src/api/repositories/common/common.repository';
import api from 'src/api/rtk/rtk-api';

export default class AuthRepository extends CommonRepository {
  private static readonly baseRoute = '/authorization';
  private static readonly apiURL = AuthRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public authenticate = async (payload: IAuthRequestDTO): Promise<IAuthInfoDTO> => {
    try {
      const { data } = await http.post(`${AuthRepository.apiURL}/authenticate`, payload);
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  // BFF Pattern: Verifies authentication via HttpOnly cookie
  // Returns 204 if the auth_token cookie is valid, 401 if expired or absent
  public heartbeat = async (): Promise<void> => {
    try {
      await http.get(`${AuthRepository.apiURL}/heartbeat`);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public ssoAuthenticate = async (payload: ISSOAuthRequestDTO): Promise<IAuthInfoDTO> => {
    try {
      const { data } = await http.post(`${AuthRepository.apiURL}/sso/authenticate`, payload);
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public logout = async (): Promise<{ redirectUrl: string | null }> => {
    try {
      const { data } = await http.post(`${AuthRepository.apiURL}/logout`, {});
      return data;
    } catch (e) {
      return { redirectUrl: null };
    }
  };

  public refreshToken = async (): Promise<IAuthInfoDTO> => {
    try {
      const { data } = await http.post(`${AuthRepository.apiURL}/refreshtoken`, {});
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public updatePassword = async (payload: IEditPasswordRequestDTO): Promise<void> => {
    try {
      await http.put(`${AuthRepository.apiURL}/password`, payload);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public static endpoints = api.injectEndpoints({
    endpoints: (build) => ({
      initiateAgileSSO: build.query<{ legacyUrl: string }, { origin: string }>({
        query: (params) => {
          return { url: `${this.apiURL}/sso/initiateagilesso`, method: 'get', params };
        },
      }),
    }),
  });
}
